import { Component, OnInit, Input }  from '@angular/core';
import { FormGroup }                 from '@angular/forms';
import { IngChildForm }              from '../../inputs';
import { ViewChild }                 from '@angular/core';

import { EditModalComponent }        from '../edit-modal/edit-modal.component';

@Component({
  selector: 'ing-child-form',
  templateUrl: './child-form.component.html',
  styleUrls: ['./child-form.component.scss']
})
export class ChildFormComponent implements OnInit {
  @ViewChild(EditModalComponent) public editModalComponent:EditModalComponent;
  @Input() form:  FormGroup;
  @Input() input: IngChildForm;

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-child-form';
  }

  reDrawBackDrop() {
    setTimeout(() => {
      document.body.className += ' modal-open';
    }, 500);    
  }

  onCreate() {
    let params = [{}].concat(this.input.childForm.params);

    this.editModalComponent.show({
      formTitle      : this.input.childParams.newItemTitle,
      headerClass    : 'panel-primary',
      acceptBtnClass : 'btn-primary',
      inputs         : this.input.childForm.object.generateInputs.apply(null, params)
    })
    .then(data => {
      if (!!this.input.childForm.object.transform) {
        let item = [data].concat(this.input.childForm.params);

        this.input.childForm.object.transform.apply(null, item);
      }

      this.input.value.push(data);

      this.reDrawBackDrop();
    })
    .catch(error => {
      this.reDrawBackDrop();

      console.error(error);
    });
  }

  onEdit(item: any) {
    let params = [item].concat(this.input.childForm.params);

    this.editModalComponent.show({
      formTitle      : this.input.childParams.editItemTitle,
      headerClass    : 'panel-success',
      acceptBtnClass : 'btn-success',
      inputs         : this.input.childForm.object.generateInputs.apply(null, params)
    })
    .then(data => {
      this.reDrawBackDrop();

      if (!!this.input.childForm.object.transform) {
        let item = [data].concat(this.input.childForm.params);

        this.input.childForm.object.transform.apply(null, item);
      }

      let itemOr = this.input.value.find(val => {
        let result = true;

        for (let idx in item) {
          result = result && item[idx] == val[idx];
        }

        return result;
      });

      console.log(itemOr);

      for (let idx in data) {
        itemOr[idx] = data[idx];
      }
    })
    .catch(error => {
      this.reDrawBackDrop();

      console.error(error);
    });
  }

  onDelete(item: any) {
    // swal(this.configService.getDeleteConfirmObject())
    // .then(() => {
    //   this.tipoMaquinaService
    //     .delete(item.id)
    //     .subscribe(
    //       data => {
    //         swal(this.configService.getDeleteSuccessObject());

    //         this.ngOnInit();        
    //       },
    //       error => console.error(error)
    //     );
    // })
    // .catch(error => console.error(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/child-form/child-form.component.ts